__turbopack_context__.v({
  "backLink": "docs-module__hZJeFq__backLink",
  "card": "docs-module__hZJeFq__card",
  "content": "docs-module__hZJeFq__content",
  "footerLink": "docs-module__hZJeFq__footerLink",
  "highlight": "docs-module__hZJeFq__highlight",
  "layout": "docs-module__hZJeFq__layout",
  "logoLink": "docs-module__hZJeFq__logoLink",
  "main": "docs-module__hZJeFq__main",
  "page": "docs-module__hZJeFq__page",
  "pageBtn": "docs-module__hZJeFq__pageBtn",
  "pageBtnNext": "docs-module__hZJeFq__pageBtnNext",
  "pageFooter": "docs-module__hZJeFq__pageFooter",
  "pagination": "docs-module__hZJeFq__pagination",
  "sidebar": "docs-module__hZJeFq__sidebar",
  "sidebarGroup": "docs-module__hZJeFq__sidebarGroup",
  "sidebarGroupLabel": "docs-module__hZJeFq__sidebarGroupLabel",
  "sidebarHeading": "docs-module__hZJeFq__sidebarHeading",
  "sidebarItem": "docs-module__hZJeFq__sidebarItem",
  "sidebarItemActive": "docs-module__hZJeFq__sidebarItemActive",
  "sidebarLogo": "docs-module__hZJeFq__sidebarLogo",
  "sidebarLogoImg": "docs-module__hZJeFq__sidebarLogoImg",
  "step": "docs-module__hZJeFq__step",
  "stepNum": "docs-module__hZJeFq__stepNum",
  "steps": "docs-module__hZJeFq__steps",
  "title": "docs-module__hZJeFq__title",
  "topBar": "docs-module__hZJeFq__topBar",
});
